import { useQuery } from 'react-query';

import { Payload, QueryResponse, getPivotTable } from 'api/endPoints/getPivotTable';

export const getPivotTableKey = 'getPivotTable';

export const useQueryGetPivotTable = (params: Payload, endpoint: string, isPivotTableIsInView: boolean) => {
    return useQuery<QueryResponse, QueryError, QueryResponse>({
        queryKey: [getPivotTableKey, params],
        queryFn: ({ signal }) => getPivotTable(params, endpoint, signal),
        enabled: isPivotTableIsInView && params.cardCachedFilter?.filter?.filters.length !== 0,
    });
};
